module.exports = __webpack_public_path__ + "static/media/defaultPicC.05874103.jpg";